import Component from './InstagramInstantwinAnalyticsPublicHeader.vue'
export default Component
